import React, {useEffect} from 'react';
import {useSearchParams, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import axios from 'axios';
import SplashScreen from '../../../../common/components/ui/SplashScreen';
import {AppDispatch, RootState} from '../../../../store/configureStore';
import {setLocale} from '../../../../common';
import {setToken, setUser} from '../../redux/actions/authActions';
import {isAllowedLocale} from '../../../../common/utils';
import {AtzmaiUsersApiService} from '../../../../services';

const ExternalLogin = () => {
  const [searchParams] = useSearchParams();
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const currentToken = useSelector((state: RootState) => state.auth.token) as string;
  const currentUser = useSelector((state: RootState) => state.auth.user);
  const apiService = new AtzmaiUsersApiService(currentToken);

  const token = searchParams.get('token');
  const page = searchParams.get('page');
  const locale = searchParams.get('lang');

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['token'] = `${token}`;
      dispatch(setToken(token));
    }

    if (locale && isAllowedLocale(locale)) {
      dispatch(setLocale(locale));
    }
    if (page) {
      navigate(`/${page}`);
    }
  }, []);

  useEffect(() => {
    if (currentToken && !currentUser) {
      updateUser().catch(console.error);
    }
  }, []);

  const updateUser = async () => {
    try {
      dispatch(setUser(null));
      const result = await apiService.getCurrentUser();
      dispatch(setUser(result.body.currentUser));
    } catch (e) {
      dispatch(setUser(null));
    }
  };

  return <SplashScreen/>;
};

export default ExternalLogin;
